import { Link } from "react-router-dom";
import { Car } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t bg-background">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-5">
          {/* Logo and description */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center space-x-2">
              <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary">
                <Car className="h-5 w-5 text-primary-foreground" />
              </div>
              <span className="text-xl font-bold">SharePark</span>
            </Link>
            <p className="text-sm text-muted-foreground">
              Danmarks største deleøkonomi-platform for parkeringspladser.
            </p>
          </div>

          {/* Platform */}
          <div>
            <h3 className="font-semibold mb-4">Platform</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <Link to="/search" className="hover:text-foreground transition-colors">
                  Find parkeringsplads
                </Link>
              </li>
              <li>
                <Link to="/create-listing" className="hover:text-foreground transition-colors">
                  Udlej din plads
                </Link>
              </li>
              <li>
                <Link to="/dashboard" className="hover:text-foreground transition-colors">
                  Min konto
                </Link>
              </li>
              <li>
                <Link to="/favorites" className="hover:text-foreground transition-colors">
                  Favoritter
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Byer</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/parkering-koebenhavn" className="hover:text-foreground transition-colors">Parkering København</Link></li>
              <li><Link to="/parkering-aarhus" className="hover:text-foreground transition-colors">Parkering Aarhus</Link></li>
              <li><Link to="/parkering-odense" className="hover:text-foreground transition-colors">Parkering Odense</Link></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="font-semibold mb-4">Support</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <Link to="/contact" className="hover:text-foreground transition-colors">
                  Kontakt os
                </Link>
              </li>
              <li>
                <Link to="/faq" className="hover:text-foreground transition-colors">
                  Ofte stillede spørgsmål
                </Link>
              </li>
              <li>
                <a href="mailto:askyum@hotmail.com" className="hover:text-foreground transition-colors">
                  askyum@hotmail.com
                </a>
              </li>
              <li>
                <span>Tlf: 53 57 03 16</span>
              </li>
              <li>
                <span>Man-Fre 9:00-17:00</span>
              </li>
            </ul>
          </div>

          {/* Juridisk */}
          <div>
            <h3 className="font-semibold mb-4">Juridisk</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <Link to="/privacy-policy" className="hover:text-foreground transition-colors">
                  Privatlivspolitik
                </Link>
              </li>
              <li>
                <Link to="/terms-of-service" className="hover:text-foreground transition-colors">
                  Handelsbetingelser
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t text-center text-sm text-muted-foreground">
          <p>&copy; {new Date().getFullYear()} SharePark. Alle rettigheder forbeholdes.</p>
        </div>
      </div>
    </footer>
  );
}
